import { render, staticRenderFns } from "./OuInput.vue?vue&type=template&id=5555edeb&scoped=true"
import script from "./OuInput.vue?vue&type=script&lang=js"
export * from "./OuInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555edeb",
  null
  
)

export default component.exports